import { ORG_PROJECTS_QUERY_KEY } from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { projectApi } from "@/api/services";

export const useGetProjectsByOrganization = (organizationUuid?: string) => {
  return useQuery({
    queryKey: [ORG_PROJECTS_QUERY_KEY, organizationUuid],
    // NOTE: since we are only enabling the query when organizationUuid is present, we can safely use the ! operator
    queryFn: () => projectApi.getProjectsByOrganization(organizationUuid!),
    enabled: !!organizationUuid,
  });
};
